import DateFormatEnum from "constants/DateFormatEnum";
import moment from "moment";
import CercaDettalgioSimulazioneModel from "stores/ricerca/models/CercaDettalgioSimulazioneModel";
import SimulazioneModel from "stores/simulazione/models/SimulazioneModel";
import SimulazioneStepOneFormModel from "stores/simulazione/models/SimulazioneStepOneFormModel";
import FormatUtility from "./FormatUtility";
import environment from "environment";
import CercaDettalgioPreventivoModel from "stores/ricerca/models/CercaDettalgioPreventivoModel";
import CanaliModel from "../stores/lookup/models/CanaliModel";

export default class StepsUtility {
    public static setStep1FormValues = (
        dettaglioSimulazione?: CercaDettalgioSimulazioneModel,
        resumedSimulazione?: SimulazioneModel,
        canali?: CanaliModel[],
        dettaglioPreventivo?: CercaDettalgioPreventivoModel
    ) => {
        if (dettaglioSimulazione && resumedSimulazione) {
            const step1FormValues = new SimulazioneStepOneFormModel({
                cliente: dettaglioSimulazione.idAdministrativeCategory.toString(),
                idAdministration: dettaglioSimulazione.idAdministration,
                amministrazioneCensita: dettaglioSimulazione.idAdministration != null,
                amministrazioneNonCensita: dettaglioSimulazione.idAdministration == null,
                atc: dettaglioSimulazione.idAdministration
                    ? dettaglioSimulazione.atc
                    : dettaglioSimulazione.unregisteredAtcName,
                dataNascita: moment(dettaglioSimulazione.birthDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
                    DateFormatEnum.ITA_DATE
                ),
                nettoMensile:
                    dettaglioSimulazione.requestType === "CQS" || dettaglioSimulazione.requestType === "DLG"
                        ? FormatUtility.numberWithSeparators(dettaglioSimulazione.salary.toString(), 0.01)?.toString()
                        : undefined,
                pensioneNettaMensile:
                    dettaglioSimulazione.requestType === "CQP"
                        ? FormatUtility.numberWithSeparators(dettaglioSimulazione.salary.toString(), 0.01)?.toString()
                        : undefined,
                dataAssunzione:
                    dettaglioSimulazione.requestType === "CQS" || dettaglioSimulazione.requestType === "DLG"
                        ? moment(dettaglioSimulazione.hiringDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
                              DateFormatEnum.ITA_DATE
                          )
                        : undefined,
                dataDecorrenza: moment(dettaglioSimulazione.effectiveDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
                    DateFormatEnum.ITA_DATE
                ), //effective
                dataPensionamento:
                    dettaglioSimulazione.requestType === "CQP"
                        ? moment(dettaglioSimulazione.hiringDate, "YYYY-MM-DDTHH:mm:ss.SSS").format(
                              DateFormatEnum.ITA_DATE
                          )
                        : undefined,
                boxOneRata: FormatUtility.numberWithSeparators(
                    dettaglioSimulazione.payment.toString(),
                    0.01
                )?.toString(),
                boxOneDurata: dettaglioSimulazione.duration,
                canale: dettaglioSimulazione.idChannel.toString(),
                segmento: dettaglioSimulazione.idSegment.toString(),
                fonte: dettaglioSimulazione.idChannel.toString()
                    ? canali?.find((item: CanaliModel) => item.key === dettaglioSimulazione.idChannel.toString())
                          ?.source.key
                    : "",
                dettaglioFonte: dettaglioPreventivo ? dettaglioPreventivo.sourceDetail : "",
                agente: dettaglioSimulazione.idAgent.toString(),
                tipologiaPratica: resumedSimulazione.idPracticeType
                    ? resumedSimulazione.idPracticeType?.toString()
                    : environment.defaultIdPracticeType,
                dataRinnovoCq: dettaglioSimulazione.dataRinnovoCq
                    ? moment(dettaglioSimulazione.dataRinnovoCq, "YYYY-MM-DDTHH:mm:ss.SSS").format(
                          DateFormatEnum.ITA_DATE
                      )
                    : undefined,
                rataRinnovoCq: dettaglioSimulazione.rataRinnovoCq?.toString(),
                mesiRinnovoCq: dettaglioSimulazione.mesiRinnovoCq,
                idDipendenteSub: dettaglioSimulazione.idDipendenteSub,
                segnalazione: dettaglioSimulazione.segnalazione,
                dipendenteBanca: dettaglioSimulazione.dipendenteBanca,
            });
            return step1FormValues;
        }
        return new SimulazioneStepOneFormModel({});
    };
}
